import { Link } from "react-router-dom";
import { useFetch } from "../lib/api";
import { money, fmtDate, STATUS_LABELS, PAYMENT_LABELS } from "../lib/shop";
import { AdminTitle } from "./AdminLayout";

const Stat = ({ label, value, gold, testid }) => (
  <div className="card-dark p-5" data-testid={testid}>
    <p className="text-[11px] uppercase tracking-widest text-zinc-400 font-semibold">{label}</p>
    <p className={`font-display text-4xl mt-2 ${gold ? "text-gold" : ""}`}>{value}</p>
  </div>
);

export const PayBadge = ({ s }) => (
  <span className={`text-[11px] font-bold px-2 py-1 rounded ${s === "paid" ? "bg-emerald-500/15 text-emerald-300" : s === "pending" ? "bg-amber-500/15 text-amber-300" : "bg-red-500/15 text-red-300"}`}>{PAYMENT_LABELS[s]}</span>
);

export default function Overview() {
  const { data: s } = useFetch("/admin/stats");
  if (!s) return <p className="text-zinc-400">Loading...</p>;
  const stats = [
    ["Total Orders (paid)", s.total_orders], ["Orders Today", s.orders_today], ["Revenue", money(s.revenue), true], ["Revenue This Month", money(s.revenue_month), true],
    ["Pending Payment", s.pending_payment], ["Paid (to process)", s.paid_orders], ["Being Processed", s.processing], ["Shipped", s.shipped],
    ["Delivered", s.delivered], ["Cancelled", s.cancelled], ["Low Stock Products", s.low_stock.length], ["Out of Stock", s.out_of_stock.length],
  ];
  return (
    <div>
      <AdminTitle title="Overview" />
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3">
        {stats.map(([l, v, g]) => <Stat key={l} label={l} value={v} gold={g} testid={`stat-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`} />)}
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 mt-8">
        <div className="card-dark p-5 xl:col-span-2">
          <div className="flex justify-between mb-4"><h2 className="font-display text-3xl">Recent Orders</h2><Link to="/admin/orders" className="text-xs text-gold">View all</Link></div>
          <div className="divide-y divide-white/10" data-testid="overview-recent-orders">
            {s.recent_orders.length === 0 && <p className="text-sm text-zinc-500">No orders yet.</p>}
            {s.recent_orders.map((o) => (
              <Link key={o.id} to={`/admin/orders?open=${o.order_number}`} className="flex justify-between gap-3 py-3 text-sm hover:bg-white/5 px-2 rounded">
                <span><b>{o.order_number}</b> · {o.customer.first_name} {o.customer.last_name}<span className="block text-xs text-zinc-500">{fmtDate(o.created_at)} · {STATUS_LABELS[o.status]}</span></span>
                <span className="text-right"><b>{money(o.total)}</b><span className="block"><PayBadge s={o.payment_status} /></span></span>
              </Link>
            ))}
          </div>
        </div>
        <div className="space-y-6">
          <div className="card-dark p-5"><h2 className="font-display text-3xl mb-3">Best Sellers</h2>
            {s.best_sellers.map((b) => <p key={b.slug} className="flex justify-between text-sm py-1.5"><span className="truncate">{b.name}</span><b>{b.sold}</b></p>)}
          </div>
          <div className="card-dark p-5" data-testid="overview-low-stock"><h2 className="font-display text-3xl mb-3">Stock Alerts</h2>
            {s.out_of_stock.map((p) => <p key={p.id} className="text-sm py-1 text-red-300">{p.name} — OUT OF STOCK</p>)}
            {s.low_stock.map((p) => <p key={p.id} className="text-sm py-1 text-amber-300">{p.name} — {p.stock} left{p.sizes.length ? ` (sold out: ${p.sizes.join(", ")})` : ""}</p>)}
            {!s.out_of_stock.length && !s.low_stock.length && <p className="text-sm text-zinc-500">All good.</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
